// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1MWdG","name":"Header_name__39fV6","birthday":"Header_birthday__2wxFy","skeleton":"Header_skeleton__3FTzD"};